import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { HttpClient } from 'src/shared/providers/http/http-client';
import { Location } from 'src/shared/providers/location';
import { randomUUID } from 'src/shared/utils/secure-utils';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Aws } from 'src/shared/providers/aws';
import { DeviceInfoProvider } from 'src/shared/providers/device-info';
import { Auth } from 'src/providers/auth/auth';
import { JobMediasProvider } from 'src/providers/job-medias/job-medias.provider';
import { ToDosProvider } from 'src/providers/to-dos/to-dos';

@Injectable()
export class SharedLinksProvider {

  constructor(
    private httpClient: HttpClient,
    private location: Location,
    private navCtrl: CustomNavController,
    private storage: TidyStorage,
    private deviceInfo: DeviceInfoProvider,
    private auth: Auth,
    private aws: Aws,
    private jobMediasProvider: JobMediasProvider,
    private toDosProvider: ToDosProvider
  ) {}

  getSharedLink(sharedLinkUuid) {
    const url = `api/v1/tidy-website/shared-links/${sharedLinkUuid}`;
    return this.httpClient.get(url);
  }

  updateSharedLink(sharedLinkUuid, payload) {
    const url = `api/v1/tidy-website/shared-links/${sharedLinkUuid}/execute-action`;
    return this.httpClient.post(url, payload);
  }

  async buildPrivateJobMoment(data, route) {
    const location = await this.location.get();
    const response: any = {
      date: moment.utc().format('YYYY-MM-DD'),
      time: moment.utc().format('HH:mm:ss'),
      latitude: location.latitude,
      longitude: location.longitude,
      moment: data.name,
      description: data.description,
      source: route,
      moment_uuid: randomUUID()
    };
    if (location?.error) {
      response['location_error_message'] = location?.error;
    }
    return response;
  }

  /**
   * Pass only what the complete page reads. The to-dos hold live custom-field forms,
   * which the browser can't copy into history, so the list itself can't go along.
   */
  goToCompleteSharedListPage(clientName, uuid) {
    this.navCtrl.navigateForward('complete-to-do-list', { clientName, uuid });
  }

  // Sends the step to the client and only then moves the job to it. Every request
  // re-sends the earlier moments; the BE skips them by moment_uuid. If the request
  // fails, the stored moments go back to what they were and the error is thrown.
  async addSharedJobMoment(uuid, currentMoments, name, description) {
    const data = {
      name: name,
      description: description
    }
    const moment: any = await this.buildPrivateJobMoment(data, `shared_job/${uuid}`);
    const moments = [
      ...currentMoments,
      moment
    ];
    await this.storage.save(`sharedJob/${uuid}/moments`, moments);
    try {
      await this.toDosProvider.syncJob();
    } catch (err) {
      await this.storage.save(`sharedJob/${uuid}/moments`, currentMoments);
      throw err;
    }
    localStorage.setItem(`sharedJob/${uuid}/last-moment`, moment.moment);
  }

}
